var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanadaCa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.39551 0H17.6019V17H5.39554L5.39551 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.706055 0H5.39545V17H-0.706055V0ZM17.6019 0H23.7033V17H17.6053L17.6019 0ZM7.22492 8.21447L6.74648 8.37385L8.95326 10.283C9.12174 10.7711 8.89601 10.9139 8.75111 11.1729L11.1432 10.874L11.0859 13.248L11.5846 13.2347L11.4734 10.8773L13.8722 11.1596C13.724 10.8508 13.5926 10.6881 13.7273 10.1967L15.9308 8.38709L15.5467 8.24766C15.23 8.00859 15.6814 7.09552 15.7488 6.51776C15.7488 6.51776 14.4652 6.95272 14.3809 6.72364L14.0508 6.10275L12.8817 7.37109C12.7537 7.40099 12.6997 7.35115 12.6695 7.2449L13.2085 4.59531L12.3527 5.07011C12.282 5.10333 12.2112 5.07677 12.1641 4.99375L11.3386 3.36678L10.4896 5.05686C10.4256 5.11661 10.3616 5.12323 10.3077 5.08343L9.49232 4.63186L9.98424 7.25819C9.94381 7.36444 9.84947 7.391 9.74166 7.33458L8.61973 6.08281C8.47486 6.31525 8.37715 6.69042 8.18176 6.77677C7.98971 6.85645 7.33945 6.61739 6.90482 6.52442C7.05307 7.05234 7.51803 7.92891 7.22492 8.21776V8.21447Z",
    fill: "#D52B1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanadaCa);
export default __webpack_public_path__ + "static/media/Canada (CA).831c88770780608a36205bbffa7b0284.svg";
export { ForwardRef as ReactComponent };